import styled from "styled-components";

export const CrumbList = styled.ul`
    display: flex;
    li{
        margin-right: 10px;
        font-size: 12px;
        list-style-type: none;
        cursor: pointer;
    }
    li a{
        display: flex;
        align-items: center;
        color: #008cff;
        &::after{
            display: inline-flex;
            border: solid #9B9B9B;
            border-width: 0 1px 1px 0;
            padding: 2px;
            transform: rotate(-45deg);
            content: "";
            margin-left: 5px;
        }
    }
    li:last-child a{
        color: #fff;
        pointer-events: none;
        &::after{
            display: none;
        }
    }
`;